import { getDefaultLandingPath } from '@consts/permissions';
import { useAuthStore } from '@stores/authStore';
import React from 'react';
import { Navigate } from 'react-router-dom';

export const RedirectPage: React.FC = () => {
  const user = useAuthStore((state) => state.user);
  const to = user ? getDefaultLandingPath(user.authorizations || []) : '/dashboard';
  return <Navigate to={to} replace />;
};

export default RedirectPage;
